import type { CheckoutOrderCoupon } from './api';
import { currentLocaleTag, tr } from '../i18n';
import { formatMoney, subtractMoney } from './money';

export function OrderCouponDetails({ coupon, productTitle }: { coupon: CheckoutOrderCoupon; productTitle?: string }) {
  const discountRule = coupon.type === 'percent' && coupon.percent !== undefined
    ? new Intl.NumberFormat(currentLocaleTag(), { style: 'percent', maximumFractionDigits: 3 }).format(coupon.percent / 100)
    : coupon.type === 'fixed' && coupon.configuredAmount
      ? formatMoney(coupon.configuredAmount)
      : null;
  const afterDiscount = subtractMoney(coupon.amountBeforeDiscount, coupon.discountAmount);

  return (
    <section className="vp-order-coupon" aria-label={tr('coupon.label', { code: coupon.code })}>
      <h2>{tr('coupon.label', { code: coupon.code })}</h2>
      {productTitle && <p className="vp-order-coupon-scope">{tr('coupon.appliesToProduct', { product: productTitle })}</p>}
      <dl>
        <div><dt>{tr(coupon.type === 'percent' ? 'coupon.percentDiscount' : 'coupon.fixedDiscount')}</dt><dd>{discountRule ?? tr('common.unavailable')}</dd></div>
        <div><dt>{tr('coupon.beforeDiscount')}</dt><dd>{formatMoney(coupon.amountBeforeDiscount)}</dd></div>
        <div><dt>{tr('coupon.discountAmount')}</dt><dd>−{formatMoney(coupon.discountAmount)}</dd></div>
        <div><dt>{tr('coupon.afterDiscount')}</dt><dd>{formatMoney(afterDiscount)}</dd></div>
      </dl>
    </section>
  );
}
